// Icona "Sposta su tavolo" (stile external link: freccia in alto a destra da un riquadro)
export default function TableDeliveryIcon({ size = 24, color = "currentColor" }) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			{/* cornice aperta in alto a destra */}
			<path
				d="M3 5a2 2 0 0 1 2-2h7v2H5v14h14v-7h2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"
				fill={color}
			/>
			{/* freccia che esce verso l'alto a destra */}
			<path
				d="M13 3h7v7h-2V6.414l-8.293 8.293-1.414-1.414L16.586 5H13Z"
				fill={color}
			/>
		</svg>
	);
}
